import * as React from "react";
import LookupTableFieldValueProviderForm from "./LookupTableFieldValueProviderForm";
const LookupTableFieldValueProviderFormContainer = ({ ...otherProps }) => /* @__PURE__ */ React.createElement(LookupTableFieldValueProviderForm, { ...otherProps });
export default LookupTableFieldValueProviderFormContainer;
